const minLength = (value, minLength) =>
  value &&
  minLength &&
  String(value).length < minLength &&
  `Must have at least ${minLength} characters.`;

export default minLength;
